export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // ufo grey,
  MAIN_COLOR: '#243882', // ufo dark blue
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#E94E24', // ufo flash blue
  SECONDARY_COLOR: '#282B34', // UFO secondary
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
